<template>
    <section class="pageSection">
        <sync-loader v-show="loading" class="load-spinner" :loading="loading" :size="30" :sizeUnit="'px'"></sync-loader>
        <transition name="fade" @enter="enter" @afterEnter="afterEnter">
            <div v-if="!sended" class="section_columns air-lg">
                <div >
                    <h1>Certifícate en 20 minutos</h1>
                    <p>Supera el <b>test de conocimientos</b> sobre ONiAd para obtener tu certificado.</p>
                    <p>Recibirás un correo electrónico con acceso personalizado al examen.</p>
                    <div class="form-vue">
                        <div class="form-group-vue flex-column">
                            <float-label  :main-label="'Escribe un email'" :main-small="'Recibirás un enlace exclusivo de acceso al test'">
                                <input :placeholder="'Email'"  v-model="email" class="form-control" type="email">
                            </float-label>
                        </div>
                        <div class="form-group-vue align-left">
                            <label for="terms">
                                <input type="checkbox" id="terms" v-model="termsAccept"> <small>Acepto los <a href="https://platform.oniad.com/terms" target="_blank">términos y condiciones</a></small>
                            </label>
                        </div>
                        <div class="form-group-vue align-left" v-show="errorMail">
                            <div class="error">Introduce un email válido</div>
                        </div>
                        <div class="form-group-vue align-left" v-show="acceptedMandatory === true">
                            <div class="error">Es necesario acceptar los términos y condiciones para acceder al test</div>
                        </div>
                        <div class="form-group-vue">
                            <button class="btn btn-success btn-lg" @click="sendCertificateRequest()">Solicitar acceso</button>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="../assets/images/ONiAd-Academy-imagen-1.png" alt="" style="max-width: 500px;">
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
            <div v-if="sended" style="padding: 2em;">
                <h1>¡Revisa tu bandeja de entrada!</h1>
                <p>Te hemos enviado un correo electrónico a {{email}} para que puedas acceder a tu examen.</p>
                <p>¿Te has equivocado de correo electrónico? <br> No hay problema, puedes volver a <a href="#" @click.prevent="sended = false">solicitar acceso</a></p>
                <router-link  tag="button" :to="{name: 'temary', params:{courseSlug:$route.params.courseSlug}}" class="btn btn-success btn-lg">Ver temario</router-link>
            </div>
        </transition>
    </section>
</template>

<script>
    /* eslint-disable */
    import Vue from 'vue'
    import {mapState} from 'vuex'
    import FloatLabel from "./elements/FloatLabel";
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    Vue.use(VueReCaptcha, {
        // siteKey: 'VUE_APP_SITEKEY_GOOGLE=6LeCHWEUAAAAADQ7nd_fa9zFdzST_rT7I1S3TU5A',
        siteKey: '6LdwsMMUAAAAAL_WkqDxsjhwD4gKvDLARybGJthf',
        loaderOptions: {
            useRecaptchaNet: true,
            autoHideBadge: true
        }
    });
    const uuidv4 = require('uuid/v4');


    export default {
        name: 'certificateRequest',
        components:{
            FloatLabel
        },
        computed: mapState(['courses','user']),
        data(){
            return{
                email: '',
                sended: false,
                emailJson: {},
                idUser: uuidv4(),
                loading: false,
                errorMail: false,
                acceptedMandatory: false,
                termsAccept: false
            }
        },
        mounted() {
            this.loading = true;
            let u = Vue.$sessionStorage.get('user',null);
            if (u.email){
                this.email = u.email;
                this.createSend();
            }
        },
        methods: {
            sendCertificateRequest(){
                let userExists = false;

                this.errorMail = false;
                this.acceptedMandatory = false;
                if (!this.termsAccept) {
                    this.acceptedMandatory = true;
                    return false;
                }
                if (!/\S+@\S+\.\S+/.test(this.email) || !this.email.length) {
                    this.errorMail = true;
                    return false;
                }
                this.loading = true;
                this.$recaptcha().then((token) => {
                    // console.log(token) // Will print the token
                    if(!token){return false;}

                    this.createSend();
                }).catch(()=>{this.loading = false;});


            },
            createSend(){
                this.userExists().then((data)=>{
                    this.emailJson = {user:data.id,test:this.courses[0].id,tag:'access_request'};

                    this.sendEmail();
                })
                    .catch((e)=>{
                        if (e.status === 404){
                            this.userCreate().then(()=>{
                                this.emailJson = {user:this.idUser,test:this.courses[0].id,tag:'user_created'};
                                this.sendEmail();
                            }).catch(console.error)
                        }
                    })
            },
            userExists(){
                return this.$store.dispatch({type:'getUserByEmail',data:{email: this.email}});
            },
            userCreate(){
                return this.$store.dispatch({type:'postUser',data:{id:this.idUser,email: this.email}})
            },
            send(){
                return this.$store.dispatch({type:'postUserSendEmail',data:this.emailJson})
            },
            sendEmail: async function(){
                this.loading = true;
                let result = await this.send();
                this.sended = true;
                this.loading = false;
                return result

            },

            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },
            enter(element) {
                const { height } = getComputedStyle(element);

                element.style.height = this.prevHeight;

                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
        }
    }

</script>

<style lang="scss">
    .text-center{
        text-align: center;
    }

</style>
